import { jsx as _jsx } from "react/jsx-runtime";
import { useMutation, useQuery, useSubscription } from "@apollo/client/react";
import { useAppDispatch } from "@/app/hooks";
import { addErrorToast } from "@/features/toastSlice";
import { SetUserStatusDocument, UserStatusDocument, UserStatusEventsDocument } from "@/gql/graphql";
import { useStatusSocket } from "@/hooks/use-status-socket";
import { IgorSelect } from "../forms/IgorSelect";
import { useSidebar } from "../ui/sidebar";
const USER_STATUS_OPTIONS = [
    { value: "READY", label: "🟢 verfügbar" },
    { value: "AWAY", label: "🔴 nicht verfügbar" },
];
const ICON_OPTIONS = [
    { value: "READY", label: "🟢" },
    { value: "AWAY", label: "🔴" },
];
export default function UserStatusSelector() {
    const dispatch = useAppDispatch();
    const { open } = useSidebar();
    useStatusSocket();
    const { data, refetch } = useQuery(UserStatusDocument);
    const [setUserStatus, { loading: settingStatus }] = useMutation(SetUserStatusDocument, {
        refetchQueries: [{ query: UserStatusDocument }],
    });
    useSubscription(UserStatusEventsDocument, {
        onData: () => {
            refetch();
        },
    });
    async function setStatus(status) {
        try {
            if (!status)
                return;
            const { data } = await setUserStatus({ variables: { status } });
            if (!data?.setUserStatus) {
                dispatch(addErrorToast());
            }
        }
        catch (e) {
            console.log(e);
            dispatch(addErrorToast());
        }
    }
    if (!data?.userStatus)
        return null;
    const currentStatus = data.userStatus;
    return (_jsx(IgorSelect, { options: USER_STATUS_OPTIONS, triggerOptions: !open ? ICON_OPTIONS : undefined, value: currentStatus, onChange: (v) => setStatus(v), placeholder: "Status ausw\u00E4hlen\u2026", disabled: settingStatus, className: open ? "w-full px-3" : "w-8 px-0 select-trigger--collapsed flex items-center justify-center" }));
}
